export default __webpack_public_path__ + "static/media/Eduardo-Vargas.2c908407.vcf";